import mime from "mime-types";
import { store } from "@store";
import { showDownloadReportModal } from "@actions/modals";

export const newFile = (data, fileName, contentType) => {
  const blob = new Blob([data], { type: contentType });
  const url = window.URL.createObjectURL(blob);
  const a = document.createElement("a");
  document.body.appendChild(a);
  a.style = "display: none";
  a.href = url;
  a.download = fileName;
  a.click();
  window.URL.revokeObjectURL(url);
};

export const handleDownload = (response) => {
  const contentType = response.headers["content-type"];
  const contentDisposition = response.headers["content-disposition"];

  const extension = mime.extension(contentType) || "pdf";
  const name =
    contentDisposition
      .split("filename=")[1]
      .split(";")[0]
      .replace(/^"|"$/g, "") || `Report.${extension}`;
  const onSave = async (name) => newFile(response.data, name, contentType);
  store.dispatch(showDownloadReportModal(true, name, onSave));
};

export const base64ToBlob = (rawBase64, mime = "application/pdf") => {
  if (!rawBase64) throw new Error("No base64 data");

  // Remove surrounding quotes if present and trim
  let base64 = String(rawBase64).trim();

  // Some APIs return "\"....\"" (escaped quotes) – strip them
  if (base64.startsWith('"') && base64.endsWith('"')) {
    base64 = base64.slice(1, -1);
  }

  // If it ever includes a prefix like "data:application/pdf;base64,..."
  const commaIndex = base64.indexOf(",");
  if (commaIndex !== -1) {
    base64 = base64.slice(commaIndex + 1);
  }

  // Remove whitespace and fix missing padding
  base64 = base64.replace(/\s/g, "");
  const pad = base64.length % 4;
  if (pad === 2) base64 += "==";
  else if (pad === 3) base64 += "=";

  const binary = atob(base64); // will still throw if string is truly invalid
  const len = binary.length;
  const bytes = new Uint8Array(len);
  for (let i = 0; i < len; i++) {
    bytes[i] = binary.charCodeAt(i);
  }
  return new Blob([bytes], { type: mime });
};

export const handleDownloadBlob = (response) => {
  const { report, fileName, fileExtension } = response;

  const blob = base64ToBlob(report, "application/pdf");
  const url = URL.createObjectURL(blob);

  const link = document.createElement("a");
  link.href = url;
  link.download = `${fileName || "file"}.${fileExtension || "pdf"}`;
  document.body.appendChild(link);
  link.click();
  document.body.removeChild(link);

  URL.revokeObjectURL(url);
};
